module.exports = __webpack_public_path__ + "img/icon-score2-old.36b0cc1a.svg";